// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 893) return "static/chunks/893-4833b86a04b18189.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 937 ? "78e521c3" : chunkId) + "." + {"27":"95d6816faf5d3814","59":"fc221069782db95d","376":"5c9b27df6878e816","387":"af89db16fe452364","845":"ff9f62251720f3d2","878":"25d6920b022e11dc","885":"4d9319bb52fc80bd","937":"f81b16101195920d"}[chunkId] + ".js";
};